<template>
  <article class="infoInner">
    <div class="infoTitle">
      <h1>기업 회원 상세보기</h1>
    </div>
    <div class="profileImgBox">
      <div class="profileImgInputBox preview-image">
        <input
          class="upload-name"
          disabled="disabled"
          :style="`background-image:url(${imageUrl});`"
        />
        <label for="input-file"></label>
        <input
          type="file"
          id="input-file"
          class="upload-hidden"
          @change="setFileImage"
        />
      </div>
    </div>
    <section class="container">
      <div class="infoContain">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="infoBoxForm" @submit.prevent="handleSubmit(saveProfile)">
            <div class="flex mobileFlex">
              <div class="inputBox infoBox wd50">
                <label>아이디<span class="labelItem">*</span></label>
                <input v-model="signupInfo.id" maxlength="20" disabled />
              </div>
              <ValidationProvider
                class="inputBox infoBox wd50"
                name="이메일"
                rules="required|email"
                v-slot="{ errors }"
              >
                <label>이메일<span class="labelItem">*</span></label>
                <input v-model="signupInfo.email" maxlength="40" />
                <span class="notValidationTxt">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="flex mobileFlex">
              <ValidationProvider
                class="inputBox infoBox wd50"
                name="비밀번호"
                rules="pw"
                vid="비밀번호"
                v-slot="{ errors }"
              >
                <label
                  >비밀번호 (특수문자 포함, 8자리 이상)<span class="labelItem"
                    >*</span
                  ></label
                >
                <input
                  type="password"
                  v-model="signupInfo.password"
                  maxlength="16"
                  autocomplete="new-password"
                />
                <span class="notValidationTxt">{{ errors[0] }}</span>
              </ValidationProvider>
              <ValidationProvider
                class="inputBox infoBox wd50"
                name="담당자"
                rules="required|name"
                v-slot="{ errors }"
              >
                <label>담당자<span class="labelItem">*</span></label>
                <input v-model="signupInfo.name" maxlength="16" />
                <span class="notValidationTxt">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="flex mobileFlex">
              <ValidationProvider
                class="inputBox infoBox wd50"
                name="비밀번호 재확인"
                rules="confirmed:@비밀번호"
                vid="비밀번호 재설정"
                v-slot="{ errors }"
              >
                <label
                  >비밀번호 확인 (특수문자 포함, 8자리 이상)<span
                    class="labelItem"
                    >*</span
                  ></label
                >
                <input
                  type="password"
                  v-model="confirmedPassword"
                  maxlength="16"
                />
                <span class="notValidationTxt">{{ errors[0] }}</span>
              </ValidationProvider>
              <ValidationProvider
                class="inputBox infoBox wd50"
                name="담당자 휴대폰 번호"
                rules="required|mobileTel"
                v-slot="{ errors }"
              >
                <label
                  >담당자 휴대폰 번호<span class="labelItem">*</span></label
                >
                <input
                  v-model="signupInfo.phoneNumber"
                  @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                  maxlength="11"
                />
                <span class="notValidationTxt">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="flex mobileFlex">
              <ValidationProvider
                class="inputBox infoBox wd50"
                name="기업명"
                rules="required|corpName"
                v-slot="{ errors }"
              >
                <label>기업명<span class="labelItem">*</span></label>
                <input v-model="signupInfo.company" maxlength="42" />
                <span class="notValidationTxt">{{ errors[0] }}</span>
              </ValidationProvider>
              <ValidationProvider
                class="inputBox infoBox wd50"
                name="설립연도"
                rules="required|dateNoHyphen"
                v-slot="{ errors }"
              >
                <label>설립연도<span class="labelItem">*</span></label>
                <input
                  v-model="signupInfo.birthday"
                  maxlength="10"
                  placeholder="YYYYMMDD"
                />
                <span class="notValidationTxt">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="flex mobileFlex">
              <ValidationProvider
                class="inputBox infoBox wd50"
                name="대표 번호"
                rules="tel"
                v-slot="{ errors }"
              >
                <label>대표 번호</label>
                <input
                  v-model="signupInfo.phoneCompany"
                  @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                  maxlength="11"
                />
                <span class="notValidationTxt">{{ errors[0] }}</span>
              </ValidationProvider>
              <ValidationProvider
                class="inputBox infoBox wd50"
                name="사원수"
                rules="required"
                v-slot="{ errors }"
              >
                <label>사원수<span class="labelItem">*</span></label>
                <input
                  v-model="signupInfo.memberSize"
                  @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                  maxlength="21"
                />
                <span class="notValidationTxt">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="flex mobileFlex">
              <ValidationProvider
                class="inputBox infoBox wd50"
                name="매출 규모"
                rules="required"
                v-slot="{ errors }"
              >
                <label>매출 규모<span class="labelItem">*</span></label>
                <input v-model="signupInfo.profitSize" maxlength="21" />
                <span class="notValidationTxt">{{ errors[0] }}</span>
              </ValidationProvider>
              <div class="inputBox infoBox wd100">
                <label>홈페이지</label>
                <input v-model="signupInfo.homePage" maxlength="85" />
              </div>
            </div>
            <div class="flex mobileFlex">
              <ValidationProvider
                class="inputBox infoBox wd50"
                name="업종"
                rules="required"
                v-slot="{ errors }"
              >
                <label>업종<span class="labelItem">*</span></label>
                <div class="bspSelectBox">
                  <b-form-select
                    v-model="signupInfo.fieldType"
                    :options="fieldTypeOptions"
                  ></b-form-select>
                </div>
                <span class="notValidationTxt">{{ errors[0] }}</span>
              </ValidationProvider>
              <ValidationProvider
                class="inputBox infoBox wd50"
                name="기업 형태"
                rules="required"
                v-slot="{ errors }"
              >
                <label>기업형태<span class="labelItem">*</span></label>
                <div class="bspSelectBox">
                  <b-form-select
                    v-model="signupInfo.companyType"
                    :options="companyTypeOptions"
                  ></b-form-select>
                </div>
                <span class="notValidationTxt">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="flex mobileFlex">
              <ValidationProvider
                class="inputBox infoBox wd100 addressPosition"
                name="주소"
                rules="required"
                v-slot="{ errors }"
              >
                <label>주소<span class="labelItem">*</span></label>
                <input
                  v-model="addr1"
                  readonly
                  @click="onClickSearchAdderss"
                  maxlength="40"
                />
                <input
                  type="button"
                  value="우편번호 찾기"
                  @click="onClickSearchAdderss"
                />
                <span class="notValidationTxt">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="flex mobileFlex">
              <ValidationProvider
                class="inputBox infoBox wd100 addressPosition"
                name="상세주소"
                rules="required"
                v-slot="{ errors }"
              >
                <label>상세주소<span class="labelItem">*</span></label>
                <input v-model="signupInfo.addressDetail" maxlength="85" />
                <span class="notValidationTxt">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div class="warningInfo">
              <p>
                위의 항목 중 수정을 원하는 항목을 클릭하시고 새로 수정할 정보를
                입력하세요. <br />
                정보입력 후 아래의 수정버튼을 누르시면 회원정보 수정이
                진행됩니다.
              </p>
            </div>

            <div class="btnBox flex">
              <button
                type="button"
                class="btnFont redborderBtn"
                @click="onClickBeforeBtn"
              >
                취 소
              </button>
              <button type="submit" class="btnFont redBtn">수 정</button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </section>
  </article>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import * as eventUtil from "@/utils/eventUtil";
import axios from "@/axios/axios";
import * as addressFind from "@/utils/addressFind";
import * as corpUtil from "@/utils/corpUtil";
import * as htmlUtil from "@/utils/htmlUtil";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      eventUtil: eventUtil,
      signupInfo: {
        roleName: this.$role.CORP,
        id: "",
        password: "",
        name: "",
        email: "",
        phoneNumber: "",
        birthday: "",
        address: "",
        addressDetail: "",
        company: "",
        companyType: "",
        fieldType: "",
        phoneCompany: "",
        memberSize: "",
        profitSize: "",
        homePage: "",
      },
      confirmedPassword: "",
      addr1: "", // addressFind util 주소검색 결과
      postcode: "", // addressFind util 주소검색 결과(우편번호)
      genderOptions: [
        { text: "남", value: "M" },
        { text: "여", value: "F" },
      ],
      selected: "man",
      options: [
        { text: "남", value: "man" },
        { text: "여", value: "woman" },
      ],
      fieldTypeOptions: corpUtil.fieldType,
      companyTypeOptions: corpUtil.companyType,
      imageUrl: require("@/assets/images/user/imgEnroll.png"),
      file: null,
      idx: null,
    };
  },
  created() {
    this.getUserInfo();
  },
  computed: {},
  methods: {
    onClickBeforeBtn() {
      this.$router.push({ path: "/admin/accountManagement" });
    },
    onClickSearchAdderss() {
      addressFind.FindAddress(this);
    },
    setFileImage(event) {
      let file = event.target.files[0];
      let fileName = event.target.files[0].name;

      let fileNameArr = fileName.split(".");
      let ext = fileNameArr[fileNameArr.length - 1];

      let checkExts = [
        "gif",
        "png",
        "jpg",
        "jpeg",
        "GIF",
        "PNG",
        "JPG",
        "JPEG",
      ];

      var check = checkExts.some(function(checkExt) {
        return ext === checkExt;
      });

      if (!check) {
        this.$alert(
          "알림",
          "업로드가 불가한 확장자입니다. <br>(gif, png, jpg, jpeg 파일만 업로드할 수 있습니다.)"
        );
        return;
      }

      if (file.size >= 1024 * 1024 * 10) {
        this.$alert("알림", "첨부파일은 10mb이하의 크기만 업로드 가능합니다.");
        return;
      }

      this.file = file;
      this.imageUrl = URL.createObjectURL(this.file);
    },
    getUserInfo() {
      var idx = this.$route.params.idx;

      axios
        .post("/api/profile/getProfileInfo", idx)
        .then((response) => {
          if (response.status == 200) {
            let user = response.data.USER;
            this.signupInfo.id = user.id;
            this.signupInfo.email = user.email;
            this.signupInfo.phoneNumber = user.phoneNumber;
            this.signupInfo.name = user.name;
            this.signupInfo.birthday = user.birthday;
            this.signupInfo.gender = user.gender;
            this.addr1 = htmlUtil.stringToTag(user.address);
            this.signupInfo.address = user.address;
            this.signupInfo.addressDetail = htmlUtil.stringToTag(
              user.addressDetail
            );
            this.signupInfo.company = user.company;
            if (user.companyType) {
              this.signupInfo.companyType = user.companyType;
            }
            if (user.fieldType) {
              this.signupInfo.fieldType = user.fieldType;
            }
            this.signupInfo.phoneCompany = user.phoneCompany;
            this.signupInfo.memberSize = user.memberSize;
            this.signupInfo.profitSize = user.profitSize;
            this.signupInfo.homePage = user.homePage;
            this.imageUrl = user.saveFileName;
          }
        })
        .catch((error) => {
          this.$alert(
            "알림",
            "상세정보를 불러오는 중 에러가 발생했습니다. 관리자에게 문의해주세요.<br>" +
              error
          );
        });
    },
    saveProfile() {
      let idx = this.$route.params.idx;

      const formData = new FormData();
      if (idx) {
        formData.append("IDX", idx);
      }
      formData.append("THUMBNAIL_IMG", this.file);
      formData.append("PASSWORD", this.signupInfo.password);
      formData.append("EMAIL", this.signupInfo.email);
      formData.append("PHONE_NUMBER", this.signupInfo.phoneNumber);
      formData.append("NAME", this.signupInfo.name);
      formData.append("BIRTHDAY", this.signupInfo.birthday);
      formData.append("GENDER", this.signupInfo.gender);
      formData.append("ADDRESS", this.addr1);
      formData.append("ADDRESS_DETAIL", this.signupInfo.addressDetail);
      formData.append("COMPANY", this.signupInfo.company);
      formData.append("COMPANY_TYPE", this.signupInfo.companyType);
      formData.append("FIELD_TYPE", this.signupInfo.fieldType);
      formData.append("PHONE_COMPANY", this.signupInfo.phoneCompany);
      formData.append("MEMBER_SIZE", this.signupInfo.memberSize);
      formData.append("PROFIT_SIZE", this.signupInfo.profitSize);
      formData.append("HOMEPAGE", this.signupInfo.homePage);

      var response = this.$createConfirmResponse();
      this.$confirm(
        "알림",
        "회원정보 수정 시 기존의 정보는 삭제되고 새로 입력하신 정보로 변경됩니다. 그래도 입력하신 부분의 정보수정을 진행하시겠습니까?",
        "확인",
        "취소",
        response,
        {
          closed: () => {
            if (response.result) {
              axios
                .post("/api/profile/update", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                })
                .then((result) => {
                  if (result.status == 200) {
                    this.$alert("알림", "회원정보가 수정되었습니다.", "", {
                      closed: () => {
                        this.$router.push({ path: "/admin/accountManagement" });
                      },
                    });
                  }
                })
                .catch((error) => {
                  this.$alert(
                    "알림",
                    "회원정보 수정 중 에러가 발생했습니다. 관리자에게 문의해주세요. <br>" +
                      error
                  );
                });
            }
          },
        }
      );
    },
  },
};
</script>

<style scoped>
.infoInner > .infoTitle {
  padding: 0 100px;
}
.infoInner > div > h1 {
  color: #9e1915;
}
input:disabled {
  color: #7d7d7d;
}
.profileImgBox {
  padding: 40px 0;
  text-align: center;
}
.profileImgInputBox {
  position: relative;
}
.profileImgInputBox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.profileImgInputBox label:active {
  transform: scale(0.97);
}
.profileImgInputBox label {
  position: absolute;
  z-index: 1;
  width: 190px;
  height: 190px;
  color: #fff;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: transparent;
  cursor: pointer;
  left: 50%;
  margin-left: -95px;
}
.profileImgInputBox .upload-name {
  border: 0;
  display: inline-block;
  width: 190px;
  height: 190px;
  padding: 6px 20px 5px; /* label의 패딩값과 일치 */
  font-size: inherit;
  font-family: inherit;
  line-height: normal;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-size: 80%;
  background-position: center;
  /* background-image: url('../../../assets/images/user/imgEnroll.png'); */
  -webkit-appearance: none; /* 네이티브 외형 감추기 */
  -moz-appearance: none;
  appearance: none;
}
/* preview img */
.filebox .upload-display {
  /* 이미지가 표시될 지역 */
  margin-bottom: 5px;
}
@media (min-width: 768px) {
  .filebox .upload-display {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 0;
  }
}
.filebox .upload-thumb-wrap {
  /* 추가될 이미지를 감싸는 요소 */
  display: inline-block;
  width: 54px;
  padding: 2px;
  vertical-align: middle;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
}
.filebox .upload-display img {
  /* 추가될 이미지 */
  display: block;
  max-width: 100%;
  width: 100% \9;
  height: auto;
}
</style>

<style scoped lang="scss">
.bspRadio ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
}
.bspSelectBox ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
  @import "~bootstrap-vue/dist/bootstrap-vue.min";
}
</style>
